export default __webpack_public_path__ + "navigation-guides-free-drive-ui-1200-9dc93df612e58d109d5aa6044f590a55.webp";